import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const LoanMappingCreateModalUI = ({ context, loan, successMsg, errorList, setErrorList,
    // sourceValue
    sourceValue, onSourceValueChange, sourceValueError, setSourceValueError,
    // superuser role
    mappedValue, onMappedValueChange, mappedValueError, setMappedValueError,
    // modes
    createMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
}) =>
    <ModalFormUI
        context={context}
        loan={loan}
        titleLabel='Add mappings'
        buttonLabel='Add'
        cancelLabel='Cancel'
        isOpen={createMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='sourceValue' label='Label' maxLength={100}
            value={sourceValue} onChange={onSourceValueChange}
            error={sourceValueError} setError={setSourceValueError}
            autoFocus={true}
        />
        <InputTextSF type='text' name='mappingValue' label='Value' maxLength={100}
            value={mappedValue} onChange={onMappedValueChange}
            error={mappedValueError} setError={setMappedValueError}
        />
    </ModalFormUI>

export default LoanMappingCreateModalUI
